import React, { useEffect, useMemo, useRef, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";

const FileItem = ({
  files,
  folderState,
  handleAllCheckboxClick,
  toggleFileItem,
  selectedFiles,
  setPageNumber,
  handleImageClick,
  setLoadingImages,
  loadingImages,
  isDetail,
}) => {
  const observerTargetRef = useRef();
  const isLoading = useSelector((state) => state?.loading?.isLoading);
  const [isImageLoading, setIsImageLoading] = useState(false);

  let globalIndex = 0;

  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, { threshold: 0.5 });
    if (observerTargetRef.current) {
      observer.observe(observerTargetRef.current);
    }

    return () => {
      if (observerTargetRef.current) {
        observer.unobserve(observerTargetRef.current);
      }
    };
  }, []);

  const handleObserver = (entries) => {
    const target = entries[0];
    if (target.isIntersecting && !isLoading && !isDetail) {
      setPageNumber((page) => page + 1);
    }
  };

  const handleImageLoad = (filePath) => {
    setLoadingImages((prev) => ({ ...prev, [filePath]: true }));
    if (!isImageLoading) {
      setIsImageLoading(true);
    }
  };

  // 사진, 파일, 비디오 분류
  const isFileType = (item) => {
    if (folderState.fileType === "I") {
      return (
        <>
          {!loadingImages[item.filePath] && <Skeleton height={"100%"} width={"100%"} />}
          <img
            src={imgHandler(item.filePath, false)}
            onError={(e) => (e.target.src = imgHandler(item.filePath))}
            onLoad={() => handleImageLoad(item.filePath)}
            decoding="async"
          />
          <p></p>
        </>
      );
    }
    if (folderState.fileType === "F") {
      return (
        <>
          <img src="/img/file.png" />
        </>
      );
    }
    if (folderState.fileType === "V") {
      return <img src="/img/video.png" />;
    }
  };

  const memoizedFiles = useMemo(() => files, [files]);
  const allFiles = useMemo(() => {
    return files?.[folderState.fileType] ? Object.values(files[folderState.fileType]).flat() : [];
  }, [files, folderState.fileType]);

  return (
    <div className="filesContainer">
      <div className="content">
        {memoizedFiles[folderState.fileType] &&
          Object.entries(files[folderState.fileType]).map(([date, data]) => (
            <div key={date} className="dateGroup">
              <div className="dateHeader">
                <input
                  type="checkbox"
                  checked={data.every((item) => selectedFiles.includes(item))}
                  onChange={(e) => handleAllCheckboxClick(data, e.target.checked)}
                />
                <span>{date}</span>
              </div>
              {data.length > 0 && (
                <>
                  <ul className="fileGroup">
                    {data.map((item, idx) => {
                      const reverseIndex =
                        allFiles.length - allFiles.findIndex((f) => f.filePath === item.filePath);

                      return (
                        <li
                          key={idx}
                          className="fileItem"
                          data-path={item.filePath}
                          onClick={() => handleImageClick(item)}>
                          <div className="preview">{isFileType(item, idx)}</div>
                          <p className="comment">
                            {folderState?.fileType === "I" && <strong>{reverseIndex}</strong>}
                            {folderState?.fileType === "F" ? (
                              <span>{item.fileNm}</span>
                            ) : folderState?.fileType === "I" ? (
                              <span>{item?.lastComment}</span>
                            ) : null}
                          </p>
                          <span
                            className="selected"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleFileItem(item);
                            }}>
                            {selectedFiles.includes(item) && (
                              <i>{selectedFiles.indexOf(item) + 1}</i>
                            )}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </>
              )}
            </div>
          ))}
      </div>
      <div id="observer" ref={observerTargetRef} style={{ height: "10px" }}></div>
    </div>
  );
};

export default FileItem;
